// extracted by mini-css-extract-plugin
export default {"todosContainer":"Main_todosContainer__S0Dn6"};